import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  flatIconButton: { padding: 0 },
  chevron: { marginLeft: '-5px' },
  kitIcon: { width: '22px', height: '22px', marginTop: '5px' },
  kitName: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  },
}));
